export default __webpack_public_path__ + "static/media/Rukoo.e876d92b.mp3";